import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { FieldPathByValue } from 'react-hook-form';

import { Varmesentral } from '../../../../../../../components/registering/utils/registerEnums';
import { useOppvarmingFormContext } from '../../utils';
import { OppvarmingFormData } from '../../../types';

type VarmesentralPath = FieldPathByValue<OppvarmingFormData, Varmesentral | undefined>;

interface Props {
  name: VarmesentralPath;
  description?: string;
}

export const VarmesentralRadio: FC<Props> = ({ name, description }) => {
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.common.varmesentral.type' });
  const { register, getFieldState } = useOppvarmingFormContext();

  const { error } = getFieldState(name);

  return (
    <Fieldset>
      <Fieldset.Legend>{t('label')}</Fieldset.Legend>
      {description && <Fieldset.Description>{description}</Fieldset.Description>}

      <Radio
        aria-invalid={!!error}
        {...register(name, { required: t('error'), shouldUnregister: true })}
        label={t(`options.${Varmesentral.AutomatikkMedUtefolerTidsstyrt}`)}
        value={Varmesentral.AutomatikkMedUtefolerTidsstyrt}
      />
      <Radio
        aria-invalid={!!error}
        {...register(name, { required: t('error'), shouldUnregister: true })}
        label={t(`options.${Varmesentral.AutomatikkMedUtefolerIkkeTidsstyrt}`)}
        value={Varmesentral.AutomatikkMedUtefolerIkkeTidsstyrt}
      />
      <Radio
        aria-invalid={!!error}
        {...register(name, { required: t('error'), shouldUnregister: true })}
        label={t(`options.${Varmesentral.UtenAutomatikk}`)}
        value={Varmesentral.UtenAutomatikk}
      />
      <Radio
        aria-invalid={!!error}
        {...register(name, { required: t('error'), shouldUnregister: true })}
        label={t(`options.${Varmesentral.Ukjent}`)}
        value={Varmesentral.Ukjent}
      />

      {!!error?.message && <ValidationMessage data-color="danger">{error.message}</ValidationMessage>}
    </Fieldset>
  );
};
